/**
 * CSV gerado no navegador (nada vai ao servidor) — um só lugar para escapar as células.
 *
 * 🚨 INJEÇÃO DE FÓRMULA: nome de produto/pessoa vem do HOS e do cadastro. Uma célula que começa
 * com `=`, `+`, `-`, `@`, TAB ou CR vira fórmula quando o arquivo abre no Excel/LibreOffice
 * (`=HYPERLINK(...)`, `=cmd|...`). Essas células ganham um apóstrofo na frente, que o Excel
 * mostra como texto. Número puro ("-12,50", "+3") não é fórmula e passa intacto — senão a coluna
 * de valores negativos deixava de somar.
 */

export type Celula = string | number | null;

const BOM = String.fromCharCode(0xfeff);

const PERIGOSO = /^[=+\-@\t\r]/;
const NUMERO = /^[-+]?\d+(?:[.,]\d+)*$/;

/** O texto de UMA célula, já protegido contra fórmula e com aspas quando precisa. */
export function celulaCsv(v: Celula): string {
  let s = v === null ? '' : typeof v === 'number' ? String(v).replace('.', ',') : v;
  if (typeof v === 'string' && PERIGOSO.test(s) && !NUMERO.test(s)) s = `'${s}`;
  return /[;"\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** As linhas em texto CSV (separador `;`, fim de linha CRLF, com BOM para o Excel ler acento). */
export function textoCsv(linhas: readonly (readonly Celula[])[]): string {
  return `${BOM}${linhas.map((l) => l.map(celulaCsv).join(';')).join('\r\n')}`;
}

/** Baixa o CSV com o nome dado. */
export function baixarCsv(nome: string, linhas: readonly (readonly Celula[])[]): void {
  const url = URL.createObjectURL(new Blob([textoCsv(linhas)], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1500);
}
